import React from "react";
import { Modal as AntModal } from "antd";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { Slide } from "react-slideshow-image";
import { SimpleSlideImage } from "./../ProceedTopUp.style";

const Modal = styled(AntModal)`
  .ant-modal-content {
    text-align: center;
  }

  .ant-modal-footer {
    text-align: center;

    .ant-btn-default {
      display: none !important;
    }
  }
`;

export const SliderContainer = styled.div`
  text-align: center;
  margin-top: 8px;

  .indicators {
    margin-top: 8px !important;
    margin-bottom: 0px !important;
    padding: 0 !important;
  }

  .react-slideshow-container + ul.indicators {
    .each-slideshow-indicator:before {
      background: #004F9C;
    }
  }
`;

const SimpleImageModal = ({ open, onOk, receiving_account, active_topup_screenshot }) => {
  const { t } = useTranslation();

  return (
    <Modal
      centered
      destroyOnClose
      closable={false}
      open={open}
      width={350}
      okText={t("common.ok")}
      onOk={onOk}
      title={active_topup_screenshot ? '' : t("wallet.proceedTopUpLast8Digits")}
    >
      {!active_topup_screenshot && t("wallet.topupSampleDrawerSubTitle")}
      <SliderContainer>
        {((!active_topup_screenshot && receiving_account?.payment_category_view_sample_images?.length > 0) ||
          (active_topup_screenshot && receiving_account?.payment_category_view_topup_images?.length > 0)) && (
            <Slide
              arrows={false}
              autoplay={true}
              indicators={true}
              duration={3000}
              transitionDuration={500}
            >
              {active_topup_screenshot
                ? receiving_account?.payment_category_view_topup_images?.map(
                  (image, key) => (
                    <SimpleSlideImage key={key} src={image} />
                  )
                )
                : receiving_account?.payment_category_view_sample_images?.map(
                  (image, key) => (
                    <SimpleSlideImage key={key} src={image} />
                  )
                )}
            </Slide>
          )}
      </SliderContainer>
    </Modal>
  );
};

export default SimpleImageModal;
